import { boolean, snakeCase, text, varchar } from 'drizzle-orm/pg-core'
import { id, timestamps } from '../utils/columns.helpers'

export const benefitTypesTable = snakeCase.table('benefit_types', {
    id: id('btp'),
    name: varchar({ length: 100 }).notNull().unique(), // flat_discount/percentage_discount/raffle/bulk/free_upgrade/cashback
    description: text(),
    isActive: boolean().notNull().default(true),
    ...timestamps,
})
